// extracted by mini-css-extract-plugin
export default {"item":"ContractView_item__E23c3","tools":"ContractView_tools__TeN3X"};